'use client'

import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { FeatureCardsDSWidget } from './feature-cards-ds-widget'
import { FeatureCardsWidgetLegacy } from './feature-cards-widget-legacy'

import type { FeatureCardsWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

// Router: DS branch when the Design System gate is active, else the legacy widget.
const FeatureCardsWidgetComponent = (props: PLTypedWidgetProps<FeatureCardsWidgetData>) => {
  if (shouldUseDesignSystem()) {
    return <FeatureCardsDSWidget {...props} />
  }
  return <FeatureCardsWidgetLegacy {...props} />
}

export const FeatureCardsWidget: PLTypedWidgetInterface<FeatureCardsWidgetData, WidgetType.FEATURE_CARDS> = {
  id: WidgetType.FEATURE_CARDS,
  errorBoundary: PLBaseErrorBoundary,
  render: FeatureCardsWidgetComponent,
}
